import { FormGroup } from '@angular/forms';

// Generic validator for Reactive forms
// Implemented as a class, not a service, so it can retain state for multiple forms.
export class GenericValidator {

  constructor(private validationMessages: { [key: string]: { [key: string]: string } }) { }

  processMessages(container: FormGroup): { [key: string]: string } {
    const messages: { [key: string]: string } = {};
    for (const controlKey in container.controls) {
      if (container.controls.hasOwnProperty(controlKey)) {
        const c = container.controls[controlKey];
        // If it is a FormGroup, process its child controls.
        if (c instanceof FormGroup) {
          const childMessages = this.processMessages(c);
          Object.assign(messages, childMessages);
        } else {
          // Only validate if there are validation messages for the control
          if (this.validationMessages[controlKey]) {
            messages[controlKey] = '';
            if ((c.dirty || c.touched) && c.errors) {
              Object.keys(c.errors).forEach(messageKey => {
                if (this.validationMessages[controlKey][messageKey]) {
                  messages[controlKey] += `${this.validationMessages[controlKey][messageKey]} `;
                }
              });
            }
          }
        }
      }
    }
    return messages;
  }

}
